import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSearchResults } from "src/api/sp";

export const fetchSearchResults = createAsyncThunk(
    "dashboard/searchResults",
    ({
        searchTerm,
        storeId,
        signal
    }: {
        searchTerm: string;
        storeId: string;
        signal: AbortSignal;
    }) => getSearchResults({ searchTerm, storeId, signal })
);
